module.exports = __webpack_public_path__ + "media/images/iconDelete-f3a3a31097b62bcdbdb9bcb20bb12233.png";